module.exports = __webpack_public_path__ + "public/images/stand-request.d191566c9fe05dc570f6eb206076810b.svg";